import React, { useState } from "react";
import slugify from "slugify";

import customStyles from "../customStyles/formMultiSelect.module.scss";

export default function FormMultiSelect({
  label,
  value,
  disabled = false,
  required = false,
  error = false,
  options = [],
  description,
  onChange,
  ...params
}) {
  const identifier = slugify(label);

  const [add, setAdd] = useState(false);

  return (
    <div
      className={`FormInput ${error ? "has-error" : ""} ${
        customStyles.multiselect
      }`}
    >
      <label className="FormLabel" htmlFor={identifier}>
        {label}
        {required && <span title="Pflichtfeld">*</span>}
      </label>
      {value && (
        <ul className="TagList--list">
          {value.map((v) => (
            <li key={v}>
              <div className="TagList--tag">
                {v}{" "}
                <button
                  onClick={() => onChange(value.filter((va) => va !== v))}
                >
                  ✕
                </button>
              </div>
            </li>
          ))}
          <li>
            <div className="TagList--tag">
              {add ? (
                <button onClick={() => setAdd(false)}>X</button>
              ) : (
                <button onClick={() => setAdd(true)}>+</button>
              )}
            </div>
          </li>
        </ul>
      )}
      {add ? (
        <select
          className="Select"
          name={identifier}
          disabled={disabled}
          {...params}
        >
          <option disabled selected>
            {label}
          </option>
          {options.map((option) => (
            <option
              className="text-base"
              value={option.value}
              key={option.value}
              onClick={() => {
                onChange([...value, option.value]);
                setAdd(false);
              }}
            >
              {option.text}
            </option>
          ))}
        </select>
      ) : (
        ""
      )}

      {description && (
        <p className="FormDescription" id={`${identifier}-description`}>
          {description}
        </p>
      )}
    </div>
  );
}
